import { useEffect, useRef } from 'react'

function useCSSForHeight(variableName) {
    const ref = useRef()

    useEffect(() => {
        if (ref?.current) {
            const updateHeight = () => {
                setTimeout(() => {
                    document.documentElement.style.setProperty(
                        `--${variableName}`,
                        `${ref?.current?.scrollHeight}px`
                    )
                }, 20)
            }

            const observer = new MutationObserver(updateHeight)

            observer.observe(ref.current, {
                attributes: true,
                childList: true,
                subtree: true,
            })

            // Update the height initially
            updateHeight()

            return () => {
                // Clean up the observer when the component unmounts
                observer.disconnect()
            }
        }
    }, [variableName])

    return ref
}

export default useCSSForHeight
